// Import from the concrete leaf module, not the '@utils' barrel: this file calls these
// functions at module-eval time, and the barrel sits in an import cycle with '@constants'
// (via path/helpers/translation), which would TDZ-crash if the barrel is mid-initialization.
// domain-utils.js has no imports of its own, so it is always safe to evaluate first.
import { transformConfigForCloudDomain, isConsentDomain } from '@utils/domain-utils';
import { ENV_STAGES, APP_HOST_TYPES } from './environment';

let constants = {};
if (import.meta.env.VITE_REACT_APP_STAGE === ENV_STAGES.PROD) {
  constants = window.RUNTIME_CONFIG.prod;
} else if (import.meta.env.VITE_REACT_APP_STAGE === ENV_STAGES.SANDBOX) {
  constants = window.RUNTIME_CONFIG.sandbox;
} else if (import.meta.env.VITE_REACT_APP_STAGE === ENV_STAGES.PREPROD) {
  constants = window.RUNTIME_CONFIG.preprod;
} else if (import.meta.env.VITE_REACT_APP_STAGE === ENV_STAGES.DEV) {
  constants = window.RUNTIME_CONFIG.dev;
} else {
  constants = window.RUNTIME_CONFIG.local;
  // constants = window.RUNTIME_CONFIG.preprodLocal;
}

constants = {
  ...constants,
  LOGIN: `${constants.SERVER_API_ROOT}/auth/oauth2/authorize`,
  TOKEN: `${constants.SERVER_API_ROOT}/auth/oauth2/token`,
};

// Apply domain transformation based on host type
if (import.meta.env.VITE_APP_HOST_TYPE === APP_HOST_TYPES.ON_PREM
  && (constants.SERVER_API_ROOT.includes('.consent.in') || constants.REDIRECT_URI.includes('.consent.in'))) {
// For on-prem: replace hostname using intelligent subdomain mapping
  constants = {};
} else if (import.meta.env.VITE_APP_HOST_TYPE === APP_HOST_TYPES.CLOUD && !isConsentDomain()) {
// For cloud on non-consent domains: only replace REDIRECT_URI domain
  constants = transformConfigForCloudDomain(constants);
}

export default constants;
